var _dec, _dec2, _class;
import { "BeanInfo" as __z_BeanInfo } from "zova";
import { $protocolKey } from 'zova';
import { BeanInterceptorBase, Interceptor } from 'zova-module-a-fetch';
export let InterceptorHeaders = (_dec = Interceptor({
  dependencies: 'a-interceptor:mock'
}), _dec2 = __z_BeanInfo({
  module: "a-interceptor"
}), _dec(_class = _dec2(_class = class InterceptorHeaders extends BeanInterceptorBase {
  async onRequest(config, options, next) {
    // locale
    const keyLocale = this.sys.env.APP_LOCALE_HEADER_KEY;
    if (keyLocale && !config.headers[keyLocale]) {
      config.headers[keyLocale] = this.app.meta.locale.current;
    }
    // tz
    const keyTz = this.sys.env.APP_TZ_HEADER_KEY;
    if (keyTz && !config.headers[keyTz]) {
      config.headers[keyTz] = this.app.meta.locale.tz;
    }
    // openapi schema
    if (options.openapiSchema) {
      config.headers[$protocolKey('x-vona-openapi-schema')] = true;
    }
    // next
    return next(config);
  }
}) || _class) || _class);